import { useState, type MouseEvent, type MouseEventHandler } from "react";

import ListMenu, { type ListMenuItem } from "@rio-cloud/rio-uikit/ListMenu";
import BranchesPage from "./pages/BranchesPage";
import SegmentsPage from "./pages/SegmentsPage";
import SupplierPage from "./pages/SupplierPage";
import VendorsPage from "./pages/VendorPage";
import CategoriesPage from "./pages/CategoriesPage";
import SubCategoriesPage from "./pages/SubCategoriesPage";

const menuItems = (activeItem: string, setActiveItem: MouseEventHandler<HTMLSpanElement>): ListMenuItem[] => [
  {
    group: "Configurar",
    navItems: [
      {
        key: "branches",
        item: (
          <span className={activeItem === "0" ? "active" : ""} data-key="0" onClick={setActiveItem}>
            Filiais
          </span>
        ),
      },
      {
        key: "segments",
        item: (
          <span className={activeItem === "1" ? "active" : ""} data-key="1" onClick={setActiveItem}>
            Segmentos
          </span>
        ),
      },
      {
        key: "customers",
        item: (
          <span className={activeItem === "2" ? "active" : ""} data-key="2" onClick={setActiveItem}>
            Clientes
          </span>
        ),
      },
      {
        key: "suppliers",
        item: (
          <span className={activeItem === "3" ? "active" : ""} data-key="3" onClick={setActiveItem}>
            Fornecedores
          </span>
        ),
      },
      {
        key: "categories",
        item: (
          <span className={activeItem === "4" ? "active" : ""} data-key="4" onClick={setActiveItem}>
            Categorias
          </span>
        ),
      },
      {
        key: "subcategories",
        item: (
          <span className={activeItem === "5" ? "active" : ""} data-key="5" onClick={setActiveItem}>
            SubCategorias
          </span>
        ),
      },
    ],
  },
];

const SettingsPage = () => {
  const [activeItem, setActiveItem] = useState("0");

  const onItemClick = (event: MouseEvent) => {
    const key = (event.target as HTMLSpanElement).getAttribute("data-key") as string;
    setActiveItem(key);
  };

  return (
    <div className="display-flex justify-content-start height-100pct">
      <div className="width-300 bg-white padding-top-25 height-100pct">
        <div className="margin-top-10">
          <ListMenu menuItems={menuItems(activeItem, onItemClick)} />
        </div>
      </div>
      <div className="padding-25 flex-1-0">
        {activeItem === "0" && <BranchesPage />}
        {activeItem === "1" && <SegmentsPage />}
        {activeItem === "2" && <SupplierPage />}
        {activeItem === "3" && <VendorsPage />}
        {activeItem === "4" && <CategoriesPage />}
        {activeItem === "5" && <SubCategoriesPage />}
      </div>
    </div>
  );
};

export default SettingsPage;
